import script from "./briefIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./briefIntro.vue?vue&type=script&setup=true&lang=js"

import "./briefIntro.vue?vue&type=style&index=0&id=ec185a94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec185a94"]])

export default __exports__